import userCountriesJson from "./userCountries.json";

export interface ICountriesData {
  chineseName?: string;
  commonName: string;
  displayName?: string;
  enable?: boolean;
  formalName?: string;
  id: string;
  countryCode: string;
  nationality: string;
  localName?: string;
  nationalFlag: string;
  startChar?: string;
  telephoneCode: string;
  flagIsImage?: boolean;
}

const userCountries = userCountriesJson;
const userCountriesData: ICountriesData[] = [];
const phonePrefixsTemp: string[] = [];
const tempIds: string[] = [];

Object.values(userCountries).forEach(item => {
  for (const _item of item) {
    // @ts-ignore
    if (!tempIds.includes(_item.commonName)) {
      _item.telephoneCode = `+${_item.telephoneCode}`;
      phonePrefixsTemp.push(_item.telephoneCode);
      userCountriesData.push(_item);
      // @ts-ignore
      tempIds.push(_item.commonName);
    }
  }
});

const phonePrefixs = [...Array.from(new Set(phonePrefixsTemp))];
export { userCountriesData, phonePrefixs };
